
export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Adresse modifiée',
        message: 'Votre ou vos abonnements seront expédiés à l’adresse suivante à la date de votre prochaine expédition.',
        nextShipment: 'Prochaine expédition :',
        shippingAddress: 'Adresse de livraison',
        gotIt: 'Compris'
    };

    return resources[label];
}
